module.exports = __webpack_public_path__ + "img/P28-zh.bd7259bc.png";